// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_YWX","right":"styles_right__Qyrdh"};